import * as React from 'react';

interface ExpandIconProps {
    color?: string;
    fill?: string;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({
    color = 'var(--primary-color)',
    fill = 'var(--primary-color)',
}: ExpandIconProps) => {
    return (
        <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1l6 6 6-6" stroke={color} strokeWidth="2" fill={fill} fillRule="evenodd" />
        </svg>
    );
};

export default React.memo(ExpandIcon);
